import { Grid, Typography, Box, Avatar } from '@mui/material';

import DOMPurify from 'dompurify';

import { ReactComponent as BotAvatar } from 'common/assets/images/bot.svg';
import {
	CHAT_TYPE_OPTION,
	CHAT_USER_OPTIONS,
	TAB_VALUES,
} from 'common/constants/AskRiskLinkConstants';
import { formatAssigneeName, toSentenceCase } from 'common/utils/utilFunctions';

import { IGPTMessageProps } from '../api/type-def';
import { RiskLinkUploadedDocument } from '../OpenRiskGPTUtil';

import styles from './RecordMessageView.module.scss';

export interface IRecordMessageView {
	messageDetails: IGPTMessageProps;
}
const RecordMessageView = (props: IRecordMessageView) => {
	const { messageDetails } = props;
	/* Destructured variables */
	const {
		type,
		message,
		messageId,
		name,
		time,
		sources,
		promptRole,
		component,
		documents,
	} = messageDetails;

	const { USER, BOT } = CHAT_USER_OPTIONS;
	const { DOC } = CHAT_TYPE_OPTION;
	const { PROMPT_LIBRARY } = TAB_VALUES;

	const sourceDisplayTitles =
		Array.isArray(sources) && sources?.map((obj) => obj?.title);

	return (
		<Grid item display="flex" mb={1}>
			<div id={`${type}-${messageId}`}>
				{type?.toLowerCase() === USER?.toLowerCase() ? (
					<Avatar className={styles['user-avatar']}>
						{formatAssigneeName(name)}
					</Avatar>
				) : (
					<Box className={styles['bot-avatar']}>
						<BotAvatar />
					</Box>
				)}
			</div>
			<Grid container width="100%">
				<Grid item sm={12} className={styles['user-info-section']}>
					<Typography className={styles['user-info-subsection']}>
						{name}
					</Typography>
					<Typography className={styles['user-info-seperator']} />
					<Typography className={styles['user-info-time']}>{time}</Typography>
				</Grid>
				<Grid item sm={12}>
					<Typography className={styles['bot-message-grid']}>
						{component === DOC && (
							<Typography
								className={styles['user-doc-container']}
								data-testid="uploadedDoc"
							>
								{documents?.map((docFile) => (
									<RiskLinkUploadedDocument file={docFile} key={docFile?.id} />
								))}
							</Typography>
						)}

						{component !== DOC && (
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(message?.replace(/\n/g, '<br />')),
								}}
								className={
									type?.toLowerCase() === USER?.toLowerCase()
										? styles['user-text-container']
										: ''
								}
							/>
						)}

						{type?.toLowerCase() === BOT?.toLowerCase() && (
							<>
								{promptRole && (
									<Typography className={styles['reference-section']}>
										<Typography className={styles['source-text']}>
											{toSentenceCase(PROMPT_LIBRARY)}:
										</Typography>
										<Typography className={styles['prompt-text']}>
											{promptRole}
										</Typography>
									</Typography>
								)}
								{sourceDisplayTitles && sourceDisplayTitles?.length > 0 && (
									<Typography
										className={styles['reference-section']}
										data-testid="source-display-title"
									>
										<Typography className={styles['source-text']}>
											{toSentenceCase('Source:')}
										</Typography>
										<Typography className={styles['reference-text']}>
											{sourceDisplayTitles?.length === 1
												? sourceDisplayTitles[0]
												: sourceDisplayTitles?.join(', ')}
										</Typography>
									</Typography>
								)}
							</>
						)}
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default RecordMessageView;
